import CodUserAPI from "../../api/CodUserAPI";
import {RegUserDTO, PreferredContactMethodDTO} from "../../types";
import * as action_types from './actionTypes';
import {GeneralActions} from "./GeneralActions";

export default class RegUserActions {

    static set_loading_reguser_data(loading_reguser_data: boolean) {
        return (dispatch: any) => {
            dispatch({type: action_types.REGUSER_SET_LOADING_REGUSER_DATA, loading_reguser_data});
        };
    }

    static load_reguser_data(reguser_user: RegUserDTO) {
        return async (dispatch: any) => {
            dispatch(RegUserActions.set_loading_reguser_data(true));
            const [time_zones, preferred_contact_methods] = await Promise.all([
                CodUserAPI.get_time_zones(),
                CodUserAPI.get_preferred_contact_methods()
            ]);
            const reguser_zone = time_zones.find(time_zone => time_zone.name === reguser_user.timeZone);
            dispatch(GeneralActions.set_timezones(time_zones, reguser_zone));
            dispatch(RegUserActions.set_preferred_contact_methods(preferred_contact_methods));
            dispatch(RegUserActions.set_loading_reguser_data(false));
        };
    }

    static set_reguser_profile(reguser_user: RegUserDTO) {
        return (dispatch: any) => {
        };
    }

    static set_preferred_contact_methods(lead_preferred_contact_methods: PreferredContactMethodDTO[]) {
        return (dispatch: any) => {
            const sorted_list = [...lead_preferred_contact_methods].sort((a, b) => a.order - b.order);
            dispatch({
                type: action_types.REGUSER_SET_PREFERRED_CONTACT_METHODS,
                lead_preferred_contact_methods: sorted_list
            });
        };
    }

    static load_account_branding(guid: string) {
        return async (dispatch: any) => {
            if (!guid || guid.length === 0) {
                dispatch(GeneralActions.clear_carrier_branding());
                return;
            }
            // const carrier_branding = await CarrierAPI.get_carrier_branding_configuration(guid);
            // if (!carrier_branding.show_reguser_branding) {
            //     dispatch(GeneralActions.clear_carrier_branding());
            //     return;
            // }
            // dispatch(GeneralActions.set_carrier_branding(carrier_branding));
        };
    }

    static set_selected_account_guid(guid: string) {
        return (dispatch: any) => {
            sessionStorage.setItem('selected_carrier_guid', guid);
            dispatch(this.load_account_branding(guid));
            dispatch({type: action_types.REGUSER_SET_ASSOCIATION_ACCOUNT, selected_carrier_guid: guid});
        };
    }

}
